import { Maybe } from 'types/UtilityTypes';
import { TMS } from 'types/enums/Integrations';

export const getNewCustomerURLInTMS = (
  source: Maybe<TMS>,
  tenant: Maybe<string>
): Maybe<string> => {
  switch (source) {
    case TMS.Turvo:
      return tenant
        ? `https://app.turvo.com/#/${tenant}/accounts/cards?type=shipper`
        : null;
    default:
      return null;
  }
};
